document.addEventListener('DOMContentLoaded', function() {
    class LanguageDropdown {
        constructor(element) {
            this.wrapper = element;
            this.button = element.querySelector('[data-lang-btn]');
            this.menu = element.querySelector('[data-lang-menu]');
            this.overlay = element.parentElement.querySelector('[data-lang-overlay]') || document.querySelector('[data-lang-overlay]');
            this.isOpen = false;

            if (!this.button || !this.menu) return;

            this.init();
        }

        init() {
            this.button.addEventListener('click', this.handleToggle.bind(this));
            document.addEventListener('click', this.handleClickOutside.bind(this));
            document.addEventListener('keydown', this.handleKeyboard.bind(this));
            if (this.overlay) {
                this.overlay.addEventListener('click', this.close.bind(this));
            }
        }

        handleToggle(e) {
            e.preventDefault();
            e.stopPropagation();

            this.isOpen ? this.close() : this.open();
        }

        open() {
            this.isOpen = true;
            this.menu.classList.add('active');
            this.button.setAttribute('aria-expanded', 'true');
            if (this.overlay) this.overlay.classList.add('active');
        }

        close() {
            this.isOpen = false;
            this.menu.classList.remove('active');
            this.button.setAttribute('aria-expanded', 'false');
            if (this.overlay) this.overlay.classList.remove('active');
        }

        handleClickOutside(e) {
            if (this.isOpen && !this.wrapper.contains(e.target)) {
                this.close();
            }
        }

        handleKeyboard(e) {
            if (!this.isOpen) return;

            if (e.key === 'Escape') {
                this.close();
                this.button.focus();
            }
        }

        destroy() {
            this.button.removeEventListener('click', this.handleToggle);
            document.removeEventListener('click', this.handleClickOutside);
            document.removeEventListener('keydown', this.handleKeyboard);
        }
    }

    // Inicializar todos los dropdowns
    const dropdowns = document.querySelectorAll('[data-lang-selector]');
    dropdowns.forEach(dropdown => new LanguageDropdown(dropdown));
});
